var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2294 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    transform: "translate(2294 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2129 275.994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.316 93.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.019,103.756h-30.76a2.524,2.524,0,0,0-2.512,2.512v2.855l17.338,5.368,18.447-5.368v-2.855A2.524,2.524,0,0,0,272.019,103.756Z",
    transform: "translate(-235.169 -103.756)",
    fill: "#0364b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.318,166.921a20.277,20.277,0,0,0,.626-2.514,1.192,1.192,0,0,0-.6-1.033l-.023-.012-.007,0-19.392-11.047a2.746,2.746,0,0,0-.259-.149,2.687,2.687,0,0,0-2.385,0,2.729,2.729,0,0,0-.259.149L225.63,163.359l-.007,0-.023.012a1.193,1.193,0,0,0-.6,1.033,20.256,20.256,0,0,0,.626,2.514l20.562,15.038Z",
    transform: "translate(-225.004 -139.358)",
    fill: "#0a2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.115,124.379H276.59l-3.616,5.368,3.616,5.368,12.525,10.735H299.85V135.115Z",
    transform: "translate(-260.489 -119.011)",
    fill: "#28a8ea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.746,124.379h12.525v10.735H238.746Z",
    transform: "translate(-50.854 -25.427)",
    fill: "#0078d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.99,124.379h10.735v10.735H334.99Z",
    transform: "translate(-122.048 -25.427)",
    fill: "#50d9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.8,176.362l-12.525-10.735H238.746v10.735L251.271,187.1l19.381,3.163Z",
    transform: "translate(-50.854 -55.939)",
    fill: "#0364b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.959,124.379h35.729",
    transform: "translate(-51.011 -25.427)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.868,165.627h12.525v10.735H286.868Z",
    transform: "translate(-86.451 -55.939)",
    fill: "#0078d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.746,206.874h12.525v10.735H238.746Z",
    transform: "translate(-50.854 -86.451)",
    fill: "#064a8c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.99,206.874h10.735v10.735H334.99Z",
    transform: "translate(-122.048 -86.451)",
    fill: "#0078d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 102.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.828,215.064l-21.1-15.387.884-1.555s19.225,10.95,19.519,11.115a.945.945,0,0,0,.753-.022c.274-.154,19.56-11.147,19.56-11.147l.887,1.555Z",
    transform: "translate(-212.702 -182.47)",
    fill: "rgba(10,39,103,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.077,201.032l-.023.014-.005,0L305.656,212.1a2.681,2.681,0,0,1-2.612.163l6.754,9.055,14.768,3.215v.007a2.682,2.682,0,0,0,1.109-2.172V200a1.192,1.192,0,0,1-.6,1.032Z",
    transform: "translate(-268.417 -183.899)",
    fill: "#1490df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.667,253.254v-1.32l-17.862-10.177-2.156,1.227a2.68,2.68,0,0,1-2.612.163l6.754,9.056,14.768,3.215v.007a2.683,2.683,0,0,0,1.109-2.172Z",
    transform: "translate(-268.412 -214.787)",
    fill: "rgba(0,0,0,0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.578,256.863,306,245.709l-.349.2a2.68,2.68,0,0,1-2.612.163l6.754,9.056,14.768,3.215v.007a2.686,2.686,0,0,0,1.02-1.487Z",
    transform: "translate(-268.412 -217.711)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.622,201.056v-.018H225.6l-.054-.036a1.166,1.166,0,0,1-.555-1v22.369a2.693,2.693,0,0,0,2.681,2.68h37.578a2.694,2.694,0,0,0,.662-.09,1.145,1.145,0,0,0,.322-.107.258.258,0,0,0,.107-.036,1.871,1.871,0,0,0,.411-.233l.072-.054Z",
    transform: "translate(-210.682 -183.899)",
    fill: "#28a8ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.888,169.745V140.521a2.4,2.4,0,0,0-2.385-2.385H228.63v13.34l-3.008,1.714-.007,0-.023.012a1.193,1.193,0,0,0-.6,1.032V172.13H240.5A2.4,2.4,0,0,0,242.888,169.745Z",
    transform: "translate(-210.682 -138.136)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,176.619V147.4a2.4,2.4,0,0,0-2.385-2.385H228.63v11.551l-3.008,1.714-.007,0-.023.012a1.193,1.193,0,0,0-.6,1.032V179h13.718A2.4,2.4,0,0,0,241.1,176.619Zm0-3.578V147.4a2.4,2.4,0,0,0-2.385-2.385H228.63v11.551l-3.008,1.714-.007,0-.023.012a1.193,1.193,0,0,0-.6,1.032v16.1h13.718A2.4,2.4,0,0,0,241.1,173.04Zm-1.789,0V147.4a2.4,2.4,0,0,0-2.385-2.385h-8.3v11.551l-3.008,1.714-.007,0-.023.012a1.193,1.193,0,0,0-.6,1.032v16.1h11.929A2.4,2.4,0,0,0,239.31,173.04Z",
    transform: "translate(-210.682 -143.221)",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.385,145h23.856a2.4,2.4,0,0,1,2.385,2.385v23.856a2.4,2.4,0,0,1-2.385,2.385H172.385A2.4,2.4,0,0,1,170,171.245V147.389A2.4,2.4,0,0,1,172.385,145Z",
    transform: "translate(-170 -143.216)",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.756,170.032a7.483,7.483,0,0,1,2.938-3.246,8.884,8.884,0,0,1,4.67-1.17,8.26,8.26,0,0,1,4.319,1.109,7.4,7.4,0,0,1,2.859,3.1,10.013,10.013,0,0,1,1,4.561,10.559,10.559,0,0,1-1.032,4.772,7.587,7.587,0,0,1-2.943,3.21,8.586,8.586,0,0,1-4.482,1.14,8.462,8.462,0,0,1-4.416-1.122,7.523,7.523,0,0,1-2.895-3.106,9.765,9.765,0,0,1-1.013-4.507,10.832,10.832,0,0,1,.995-4.742Zm3.131,7.619a4.858,4.858,0,0,0,1.653,2.136,4.312,4.312,0,0,0,2.582.778,4.531,4.531,0,0,0,2.757-.8,4.658,4.658,0,0,0,1.605-2.142,8.278,8.278,0,0,0,.514-2.981,9.061,9.061,0,0,0-.483-3.017,4.775,4.775,0,0,0-1.55-2.22,4.27,4.27,0,0,0-2.732-.845,4.459,4.459,0,0,0-2.643.784A4.907,4.907,0,0,0,196.9,171.5a8.548,8.548,0,0,0-.012,6.153Z",
    transform: "translate(-186.837 -158.461)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170,90.006h57.256v57.256H170Z",
    fill: "none",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook-icon.6b115359.svg";
export { ForwardRef as ReactComponent };